export const SET_PROFILE = "SET_PROFILE";
export const RESET_PROFILE = "RESET_PROFILE";
export const SET_GROUP_CODE = "SET_GROUP_CODE";
export const SET_ENTITY = "SET_ENTITY";
export const SET_OPERATION = "SET_OPERATION";

export const SET_REPORT = "SET_REPORT";
export const SET_LANGUAGE = "SET_LANGUAGE";
export const SET_RECORDS_PER_PAGE = "SET_RECORDS_PER_PAGE";
export const SET_TEST_ENVIRONMENT = "SET_TEST_ENVIRONMENT";
export const SET_PERMISSIONS = "SET_PERMISSIONS";
export const SET_DEFAULT_PERMISSIONS = "SET_DEFAULT_PERMISSIONS";
export const SET_PERMISSION_NODES = "SET_PERMISSION_NODES";
export const SET_GROUPCODE_PERMISSION = "SET_GROUPCODE_PERMISSION";
export const SET_ENTITY_PERMISSION = "SET_ENTITY_PERMISSION";
export const SET_USER_PERMISSIONS = "SET_USER_PERMISSIONS";
export const SET_USER_HAS_PERMISSIONS = "SET_USER_HAS_PERMISSIONS";
export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";
export const SET_ACCESS_TOKEN = "SET_ACCESS_TOKEN";
export const SET_LEGACY_MAPPING_FROM_FIELD_FILTER = "SET_LEGACY_MAPPING_FROM_FIELD_FILTER";
export const SET_LEGACY_MAPPING_TO_FIELD_FILTER = "SET_LEGACY_MAPPING_TO_FIELD_FILTER";
export const SET_LEGACY_MAPPING_COMMENTS_FILTER = "SET_LEGACY_MAPPING_COMMENTS_FILTER";
export const SET_EXTRACTION_RESULT_TABLE_PARAMS = "SET_EXTRACTION_RESULT_TABLE_PARAMS";

export const setProfile = (value: any) => {
  return { type: SET_PROFILE, payload: value };
};

export const setGroupCode = (value: any) => {
  return { type: SET_GROUP_CODE, payload: value };
};

export const setEntity = (value: any) => {
  return { type: SET_ENTITY, payload: value };
};

export const setOperation = (value: any) => {
  return { type: SET_OPERATION, payload: value };
};

export const setReport = (value: any) => {
  return { type: SET_REPORT, payload: value };
};

export const setLanguage = (value: any) => {
  return { type: SET_LANGUAGE, payload: value };
};

export const setRecordsPerPage = (value: any) => {
  return { type: SET_RECORDS_PER_PAGE, payload: value };
};

export const setTestEnvironment = (value: any) => {
  return { type: SET_TEST_ENVIRONMENT, payload: value };
};

export const resetProfile = () => {
  return { type: RESET_PROFILE, payload: null };
};

export const setPermissions = (value: any) => {
  return { type: SET_PERMISSIONS, payload: value };
};

export const setDefaultPermissions = (value: any) => {
  return { type: SET_DEFAULT_PERMISSIONS, payload: value };
};

export const setGroupCodePermissions = (value: any) => {
  return { type: SET_GROUPCODE_PERMISSION, payload: value };
};

export const setEntityPermissions = (value: any) => {
  return { type: SET_ENTITY_PERMISSION, payload: value };
};

export const setUserPermissions = (value: any) => {
  return { type: SET_USER_PERMISSIONS, payload: value };
};

export const setUserHasPermissions = (value: any) => {
  return { type: SET_USER_HAS_PERMISSIONS, payload: value };
};

export const setNotifications = (value: any) => {
  return { type: SET_NOTIFICATIONS, payload: value };
};

export const setAccessToken = (value: any) => {
  return { type: SET_ACCESS_TOKEN, payload: value };
};

export const setLegacyMappingFromFieldFilter = (value: any) => {
  return { type: SET_LEGACY_MAPPING_FROM_FIELD_FILTER, payload: value };
};

export const setLegacyMappingToFieldFilter = (value: any) => {
  return { type: SET_LEGACY_MAPPING_TO_FIELD_FILTER, payload: value };
};

export const setLegacyMappingCommentsFilter = (value: any) => {
  return { type: SET_LEGACY_MAPPING_COMMENTS_FILTER, payload: value };
};

export const setExtractionResultTableParams = (value: any) => {
  return { type: SET_EXTRACTION_RESULT_TABLE_PARAMS, payload: value };
}